module.exports = __webpack_public_path__ + "img/logo.fa9d354f.png";